// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__od_Ew","vertical":"styles_vertical__qs6xf"};